import {abstractFilter} from './../abstractFilter';
import {MSR} from './../../lib-memsize-parser';
function F() {
    return (F.is(this) ? this.init : F.F).apply(this, Array.prototype.slice.call(arguments));
}

var P = F.leu_extend(abstractFilter).prototype;
const BAD_MEMSIZE_VALUE = 'is not valid memsize value (xx[B*|K|M|G|T|P])';

P.apply_filter = function (current_value, params, field_name) {
    let input_value = null;
    if ((typeof current_value) === 'number' || (typeof current_value) === 'string') {
        input_value = MSR(current_value);
    } else if (MSR.is(current_value)) {
        input_value = current_value;
    }
    if (null !== input_value) {
        if (input_value.isValid()) {
            if (params.has_param('str')) {
                return input_value.toString();
            }
            return input_value;
        }
        return this.create_invalid_value(field_name, input_value.error);
    }
    return this.create_invalid_value(field_name, BAD_MEMSIZE_VALUE);
};

export default F;


